.kdx-section-title {
    @include line-height(26);
    margin: 16px 0 24px 0;        

    h2 {
        position: relative;
        padding-bottom: 16px;

        &::after {
            content: '';
            background: $sectionTitleBorderColor;
            width: 100%;
            max-width: 65px;
            height: 4px;
            position: absolute;
            top: 100%;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    &.center-aligned { text-align: center; }
    &.left-aligned { 
        text-align: left; 

        h2 {

            &::after {
                left: 0;
                transform: none;
            }
        }
    }
}




@include media-breakpoint-down(md) {
    .kdx-section-title {
        @include text-size(14);
        @include line-height(22);

        h2 {

            &::after { max-width: 45px; }
        }
    }
}
